import { Component, OnInit, Input } from '@angular/core';
import { PlanDetailsStateStructure } from '../../../configs/interfaces/planDetailsStateStructure.interface';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { BENEFITS_TYPES, PlanDetailsRenderableGroup } from '../../types/plan-details.types';

@Component({
    selector: 'app-benefit-group',
    templateUrl: './benefit-group.component.html',
    styleUrls: ['./benefit-group.component.scss'],
    standalone: false
})
export class BenefitGroupComponent implements OnInit {

  @Input() benefitGroup: PlanDetailsRenderableGroup;
  @Input() categoryName: string;
  @Input() market: string;
  
  constructor(
    private reducerUtilityService: ReducerUtilityService
  ) { }

  ngOnInit() {}

  /** PRESCRIPTION DRUG SPECIFIC FUNCTION */
  isMedicalBenefitType(benefitGroup: PlanDetailsRenderableGroup) {
    return benefitGroup.benefitsType === BENEFITS_TYPES.MEDICAL_BENEFIT;
  }

  /** Not actually a benefit, but a part of the benefitGrid object */
  isPlanDocumentBenefitType(benefitGroup: PlanDetailsRenderableGroup) {
    return benefitGroup.benefitsType === BENEFITS_TYPES.PLAN_DOCUMENTS;
  }

  isPlanDetailsFlow() {
    const planDetailsState: PlanDetailsStateStructure = this.reducerUtilityService.getState('PlanDetails');
    if (planDetailsState.individualPlanIdForPlanDetails) {
      return true;
    } else {
      return false;
    }
  }
}
